import { fetchApi } from 'Utils/utils';

let fetchSubCategories = function(ids) {
  let param = Array.isArray(ids) ? ids.map(i => `id=${i}`).join('&') : `id=${ids}`;
  return fetchApi.get(`/api/v1/category/subCategories/?${param}`);
};

export { fetchSubCategories };
